import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IFavoriteTripsForTodayFields } from "../../../../Orchestrator/Types/Types/OffersResponse";

interface IUpdatePersonalizeFavoriteTripFieldValueParams {
    fieldName: string, favoriteTrips: IFavoriteTripsForTodayFields[], value: string, valueLabel: string, valueCode: string
}

class UpdatePersonalizeFavoriteTripFieldValueAction extends BaseAction<void, IUpdatePersonalizeFavoriteTripFieldValueParams> {
    override async run(): Promise<void> {
        try {
            const { fieldName, favoriteTrips, value, valueLabel, valueCode } = this.params!;
            const newFavoriteTrips = favoriteTrips.map(trip => {
                const newTrip = { ...trip };
                if (trip.name === fieldName) {
                    newTrip.value = value;
                    newTrip.valueLabel = valueLabel;
                    newTrip.valueCode = valueCode;
                }
                return newTrip;
            });
            updateRecoilState("favoriteTripsForTodayFieldsAtom", newFavoriteTrips);
        } catch (error: any) {
            console.log("Error updatePersonalizeFavoriteTripFieldValue", error?.message);
        }
    }
}

export const updatePersonalizeFavoriteTripFieldValueAction = new UpdatePersonalizeFavoriteTripFieldValueAction();
